<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <p class="text-h4 text-center text-blue-darken-3">AQUALYS App</p>

        <p class="text-body-1 text-center">
          This is the AQUALYS management system application. Simple but elegant !
        </p>

        <v-divider class="my-4"></v-divider>

                <p class="text-h6 text-left text-blue-darken-3">Menu utilisateur</p>
        <p class="text-body-1 text-left">
          Le menu utilisateur, accessible depuis l'icône de profil en haut de l'application,
          propose les actions suivantes :
        </p>
        <ul class="text-body-1 text-left ml-6">
          <li><strong>Changer de thème</strong> : bascule entre le thème clair et le thème sombre.</li>
          <li><strong>Changer le mot de passe</strong> : ouvre le formulaire permettant de modifier le mot de passe du compte connecté.</li>
          <li><strong>Meta Données</strong> : accède à la page de gestion des métadonnées de l'application.</li>
          <li><strong>Déconnexion</strong> : ferme la session en cours et redirige vers la page de connexion.</li>
        </ul>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Sièges</p>
        <p class="text-body-1 text-left">
          La liste des « Sièges » affiche tous les sièges dans un
          tableau consultable et sélectionnable. Vous pouvez y ajouter un nouveau siège, en modifier
          un existant en cliquant sur sa ligne, supprimer un ou plusieurs sièges sélectionnés,
          rechercher des sièges par nom, signataire, téléphone ou email, et exporter le tableau.
        </p>
        <p class="text-body-1 text-left">
          Le formulaire de siège permet de créer ou modifier les
          informations d'un siège : nom, signataire, fonction du signataire, téléphone et email.
          Une fois le siège enregistré, des laveries peuvent être créées et rattachées à celui-ci
          depuis la même page.
        </p>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Laveries</p>
        <p class="text-body-1 text-left">
          La liste des « Laveries » affiche toutes les laveries dans un tableau consultable et
          sélectionnable. Des interrupteurs permettent de filtrer les laveries par statut
          (Signé, En cours, Perdu, Résilié). Vous pouvez y ajouter une nouvelle laverie, en
          modifier une existante en cliquant sur sa ligne, supprimer une ou plusieurs laveries
          sélectionnées, rechercher des laveries et exporter le tableau.
        </p>
        <p class="text-body-1 text-left">
          La fiche d'une laverie s'organise en panneaux dépliables : les informations du compte
          siège rattaché, les informations de la laverie elle-même, ainsi que ses avenants. Depuis
          cette fiche, il est possible de télécharger, imprimer ou sauvegarder le contrat, et
          d'ajouter un nouvel avenant à la laverie.
        </p>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Produits</p>
        <p class="text-body-1 text-left">
          La page « Produits » propose deux vues, sélectionnables via les boutons en haut de page :
          un <strong>Tableau</strong> et une <strong>Recherche</strong>.
        </p>
        <p class="text-body-1 text-left">
          La vue Tableau affiche tous les produits dans un tableau consultable et sélectionnable,
          avec des interrupteurs pour filtrer par statut (Disponible, Réservé, Détruit). Vous
          pouvez y ajouter un nouveau produit, en modifier un existant en cliquant sur sa ligne,
          supprimer un ou plusieurs produits sélectionnés, rechercher des produits et exporter le
          tableau.
        </p>
        <p class="text-body-1 text-left">
          La vue Recherche permet de filtrer les produits selon plusieurs critères combinés :
          fabricant, type de produit, modèle, statut du produit, statut de réservation et plage de
          dates de destruction. Depuis cette même page, chaque produit trouvé peut être édité
          individuellement.
        </p>
        <p class="text-body-1 text-left">
          Les modèles de produits sont gérés depuis la page « Modèles des produits », accessible
          depuis les métadonnées. Elle permet de filtrer les modèles par marque ou par nom, de
          créer un nouveau modèle, et de modifier un modèle existant.
        </p>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Pièces détachées</p>
        <p class="text-body-1 text-left">
          La liste des « Pièces détachées » affiche toutes les pièces dans un tableau consultable
          et sélectionnable. Des interrupteurs permettent de filtrer les pièces par fabricant
          (Speed Queen, LG, Maytag, Primus) et par type de machine (LL, SL, SLL, SSL, Condensateur,
          Armoire, Terminal, Balon, Bidon). Vous pouvez y ajouter une nouvelle pièce, en modifier
          une existante en cliquant sur sa ligne, supprimer une ou plusieurs pièces sélectionnées,
          rechercher des pièces par nom, référence, téléphone ou email, et exporter le tableau.
        </p>
        <p class="text-body-1 text-left">
          Le formulaire de pièce détachée permet de sélectionner un fabricant, puis d'associer à
          la pièce plusieurs types de machine et plusieurs modèles de produits (la liste des
          modèles dépend du fabricant choisi), en plus des informations habituelles (statut,
          désignation, référence, prix, stock, etc.).
        </p>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Tournées technicien</p>
        <p class="text-body-1 text-left">
          La liste des « Tournées technicien » affiche toutes les tournées dans un tableau
          consultable et sélectionnable. Des interrupteurs permettent de filtrer les tournées par
          statut (À faire, Assigné, En cours, Faite, Approuvé). Vous pouvez y ajouter une nouvelle
          tournée, en modifier une existante en cliquant sur sa ligne, supprimer une ou plusieurs
          tournées sélectionnées, rechercher des tournées par nom, signataire, téléphone ou email,
          et exporter le tableau.
        </p>
        <p class="text-body-1 text-left">
          Une tournée regroupe un ensemble d'activités. Le formulaire de tournée permet de saisir
          le code de la tournée, les dates de début et de fin planifiées, le statut, un ou
          plusieurs techniciens ainsi qu'un véhicule. Depuis cette page, il est également possible
          d'assigner des activités à la tournée.
        </p>

        <v-divider class="my-4"></v-divider>

        <p class="text-h6 text-left text-blue-darken-3">Activités</p>
        <p class="text-body-1 text-left">
          La liste des « Activités » affiche toutes les activités dans un tableau consultable et
          sélectionnable. Des interrupteurs permettent de filtrer les activités par statut (À
          faire, En cours, Assigné, Approuvé) et par type (Panne, Caisse, Facturation, Location,
          Enlèvement, Installation, Préparation). Vous pouvez y ajouter une nouvelle activité, en
          modifier une existante en cliquant sur sa ligne, supprimer une ou plusieurs activités
          sélectionnées, rechercher des activités par type, et exporter le tableau. Les activités
          sélectionnées peuvent également être ajoutées à une tournée existante.
        </p>
        <p class="text-body-1 text-left">
          Le formulaire d'activité permet de renseigner un sujet, le type d'activité, la tournée
          rattachée, la laverie et éventuellement le produit concernés, le statut, la priorité,
          une observation, ainsi que des sous-tâches.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup></script>
